if (!customElements.get('sticky-productform')) {
  customElements.define('sticky-productform', class StickyProductForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (!this.productForm) return;
      this._syncOptions();
      this._observeScroll();
    }

    _syncOptions() {
      // When a real option is changed, we should update the sticky option
      this.options.forEach(option => {
        const realOption = document.getElementById(option.id.replace('-sticky', ''));
        if (realOption) {
          realOption.addEventListener('change', () => {
            option.selectedIndex = realOption.selectedIndex;
          });
        }
      });

      // When a sticky option is changed, we should update the real option
      this.options.forEach(option => {
        option.addEventListener('change', () => {
          const realOption = document.getElementById(option.id.replace('-sticky', ''));
          if (realOption) {
            realOption.selectedIndex = option.selectedIndex;
            realOption.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }

    _observeScroll() {
      // When [name="add"] of productForm is not in viewport, show sticky form
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.classList.remove('is-sticky');
            document.body.style.paddingBottom = '';
          } else if (entry.boundingClientRect.y < 0) {
            // Display sticky form only when the product form is scrolled out of view upwards
            this.classList.add('is-sticky');
            // when is sticky, add space to the bottom of the page
            document.body.style.paddingBottom = `${this.offsetHeight}px`;
          }
        });
      });
      observer.observe(this.productForm.querySelector('[name="add"]'));
    }

    get productForm() {
      const id = this.getAttribute('data-product-form-id');
      return document.getElementById(id);
    }

    get options() {
      return this.querySelectorAll('[id^="Option-"]');
    }
  });
}
